import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';


export const GalleryArtworkGrid = ({ works, artists }) => {
  const [selected, setSelected] = useState(null);
  const artistById = Object.fromEntries(artists.map((artist) => [artist.id, artist]));

  if (!works.length) return null;

  return (
    <>
      <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3" data-testid="gallery-work-grid">
        {works.map((work) => {
          const ratio = work.image_width && work.image_height
            ? `${work.image_width} / ${work.image_height}`
            : '4 / 5';
          return (
            <button
              type="button"
              key={work.id}
              className="group text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#7c2434] focus-visible:ring-offset-4"
              onClick={() => setSelected(work)}
              data-testid={`gallery-work-open-${work.id}`}
              aria-label={`Enlarge ${work.title}`}
            >
              <span className="flex w-full items-center justify-center overflow-hidden bg-[#eef0f3]" style={{ aspectRatio: ratio }}>
                <img src={work.thumbnail_url || work.image_url} alt={work.title} className="h-full w-full object-contain transition-transform duration-300 group-hover:scale-[1.02]" />
              </span>
              <span className="mt-4 block font-gallery-display text-xl text-[#17243d]">{work.title}</span>
              <span className="mt-1 block text-sm text-[#5d6470]">{artistById[work.artist_id]?.display_name || 'Member artist'}</span>
              <span className="mt-1 block text-sm text-[#5d6470]">{[work.medium, work.dimensions, work.price_display].filter(Boolean).join(' · ')}</span>
            </button>
          );
        })}
      </div>

      <Dialog open={!!selected} onOpenChange={(open) => !open && setSelected(null)}>
        <DialogContent className="max-h-[92vh] max-w-5xl overflow-auto bg-white" data-testid="gallery-work-dialog">
          {selected && (
            <div>
              <DialogTitle className="font-gallery-display text-2xl text-[#17243d]">{selected.title}</DialogTitle>
              <div className="mt-5 flex max-h-[70vh] w-full items-center justify-center bg-[#eef0f3] p-3">
                <img src={selected.image_url} alt={selected.title} className="max-h-[66vh] max-w-full object-contain" />
              </div>
              <p className="mt-4 text-sm text-[#5d6470]">
                {artistById[selected.artist_id]?.display_name || 'Member artist'}
                {[selected.medium, selected.dimensions, selected.price_display].filter(Boolean).length > 0 && ' · '}
                {[selected.medium, selected.dimensions, selected.price_display].filter(Boolean).join(' · ')}
              </p>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};